// extracted by mini-css-extract-plugin
export default {"Files__viewButton":"styles_Files__viewButton__bYxcN"};